import { createMarkup } from "../../utils";
import "./styles.css";

const Terms = ({ hdg, text }) => {
  return (
    <div className="terms">
      <p className="hdg">{hdg}</p>
      <p dangerouslySetInnerHTML={createMarkup(text)} />
    </div>
  );
};

export default Terms;
